/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-array-index-key */

import Image from 'next/image';
import { WagtailStreamfieldImage } from '@/types';
import { addBaseUrl } from '@/utils/url';
import RawHtml from '@components/RawHtml';

interface Props {
  title?: string;
  iconimage: WagtailStreamfieldImage | null;
  iconsvg?: string;
  table: {
    data: string[][];
    first_row_is_table_header: boolean;
    first_col_is_header: boolean;
    table_caption?: string;
  };
}

function Table(props: Props) {
  const {
    title,
    iconimage,
    iconsvg,
    table: {
      data,
      first_row_is_table_header: firstRowIsTableHeader,
      first_col_is_header: firstColIsHeader,
      table_caption: tableCaption,
    },
  } = props;

  return (
    <div className='streamfield table'>
      {title ? <h2 className='table__title'>{title}</h2> : null}
      <div className='bg-wrapper'>
        {iconimage && !iconsvg ? (
          <div className='table__icon'>
            <Image
              src={addBaseUrl(iconimage.file.src)}
              alt={iconimage.file.alt}
              layout='intrinsic'
              objectFit='contain'
              width={78}
              height={78}
            />
          </div>
        ) : null}
        {iconsvg ? (
          <div className='table__icon'>
            <RawHtml className='table__icon' html={iconsvg} />{' '}
          </div>
        ) : null}
        <table className='table__element'>
          {tableCaption ? <caption className='table__caption'>{tableCaption}</caption> : null}
          {firstRowIsTableHeader ? (
            <thead className='table__header'>
              <tr className='table__row'>
                {data[0].map((th, thindex) => (
                  <th
                    className='table__head'
                    key={`${th}${thindex}`}
                    dangerouslySetInnerHTML={{ __html: th ?? '' }}
                  />
                ))}
              </tr>
            </thead>
          ) : null}
          <tbody className='table__body'>
            {data.map((row, trindex) => {
              if (firstRowIsTableHeader && trindex === 0) {
                return null;
              }
              return (
                <tr className='table__row' key={trindex}>
                  {row.map((td, tdindex) =>
                    firstColIsHeader && tdindex === 0 ? (
                      <th
                        className='table__head'
                        key={`${td}${tdindex}`}
                        dangerouslySetInnerHTML={{ __html: td ?? '' }}
                      />
                    ) : (
                      <td
                        className='table__data'
                        key={`${td}${tdindex}`}
                        dangerouslySetInnerHTML={{ __html: td ?? '' }}
                      />
                    ),
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Table;
